<template>
  <div>
    <div class="chart-title">
      <div>時系列分析：スポット価格</div>
      <div>(システムプライス・エリアプライス)</div>
    </div>

    <div class="chart-container">
      <div class="chart-container__header">
        <span class="chart-container__header-label">{{ chartLabel }}の取引価格</span>
        <div class="chart-container__action-area">
          <button
            class="chart-container__header-btn commonButton t-chartaccent"
            @click="isOpenCalendar = true"
          >
            日時を選択する
          </button>
          <div v-if="isOpenCalendar" class="calendar">
            <DatePicker
              v-model="rangeDate"
              is-range
              :select-attribute="selectDragAttribute"
              :drag-attribute="selectDragAttribute"
              :available-dates="availableDates"
              @drag="dragValue = $event"
              @input="isOpenCalendar = false"
            >
              <template v-slot:day-popover="{ format }">
                <div>
                  {{ format(dragValue ? dragValue.start : rangeDate.start, 'YYYY MMM D') }}
                  -
                  {{ format(dragValue ? dragValue.end : rangeDate.end, 'YYYY MMM D') }}
                </div>
              </template>
            </DatePicker>
          </div>
          <div class="chart-select-area">
            <span>選択中のエリア:</span>
            <select v-model="area" class="chart-select-area__option">
              <option v-for="[key, value] in Object.entries(areaHash)" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="showErrorText" class="errorText">
        データの取得に失敗しました。時間を置いて再度お試しください。
      </div>
      <div v-if="!showErrorText" id="detail-chart" class="jepx-price-checker"></div>
      <div class="chart-container__footer">
        <p>デフォルトでは、最新の１週間分を表示しています。</p>
        <p>高値・低値・平均：１日単位でそれぞれの値を集計しています。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { setDetailChart, areaHash } from '../../functions/drawJepxChart'
import dayjs from 'dayjs'

import Vue from 'vue'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
Vue.component('date-picker', DatePicker)

export default {
  name: 'JepxDetailChart',
  components: {
    DatePicker,
  },
  data() {
    return {
      dragValue: null,
      rangeDate: {
        start: new Date(),
        end: new Date(),
      },
      area: null,
      areaHash: areaHash,
      availableDates: { start: new Date(2018, 3, 1), end: new Date() },
      isOpenCalendar: false,
      showErrorText: false,
    }
  },
  computed: {
    chartLabel() {
      if (!this.rangeDate.start || !this.rangeDate.end) return ''
      const startDateLabel = `${this.rangeDate.start.getFullYear()}年${
        this.rangeDate.start.getMonth() + 1
      }月${this.rangeDate.start.getDate()}日`

      const endDateLabel = `${this.rangeDate.end.getFullYear()}年${
        this.rangeDate.end.getMonth() + 1
      }月${this.rangeDate.end.getDate()}日`

      return `${startDateLabel}~${endDateLabel}の${this.areaHash[this.area]}`
    },
    dateParams() {
      return {
        startDate: this.rangeDate.start,
        endDate: this.rangeDate.end,
        area: this.area,
      }
    },
    selectDragAttribute() {
      return {
        popover: {
          visibility: 'hover',
          isInteractive: false,
        },
      }
    },
  },
  watch: {
    async dateParams() {
      await setDetailChart('#detail-chart', this.dateParams)
        .then(() => {
          this.showErrorText = false
        })
        .catch(() => {
          this.showErrorText = true
        })
    },
  },
  async mounted() {
    const nowDate = new Date()
    const defaultDate = nowDate.getHours() >= 12 ? dayjs(nowDate).add(1, 'day').toDate() : nowDate

    this.availableDates.end = defaultDate

    this.rangeDate.start = dayjs(defaultDate).subtract(6, 'day').toDate()
    this.rangeDate.end = defaultDate
    this.area = 'system'

    document.addEventListener('click', this.checkClosePicker)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkClosePicker)
  },
  methods: {
    checkClosePicker(e) {
      if (!e.target.closest('.chart-container__header-btn') && !e.target.closest('.calendar')) {
        this.isOpenCalendar = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.chart-title {
  font-size: 3.2rem;
  font-weight: bold;
  text-align: center;
}

.chart-container {
  padding: 2rem 1.5rem 3rem;
  margin-top: 3.2rem;
  background: black;

  .chart-container__header {
    padding: 1.4rem 1.8rem 1.1rem;
    background: #1e1e24;

    .chart-container__header-label {
      font-size: 2.2rem;
      font-weight: bold;
    }
  }

  .chart-container__action-area {
    position: relative;
    display: flex;
    margin-top: 0.4rem;
    font-size: 1.33333rem;

    .chart-select-area {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      margin-left: 1.2rem;

      .chart-select-area__option {
        margin-left: 0.6rem;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .chart-container__header-btn {
      min-width: 2rem;
      padding: 0.2rem 0.8rem;
      color: #000000;
      background: #f3f3f3;
      border: none;
    }

    .calendar {
      position: absolute;
      top: 2rem;
      z-index: 99;
    }
  }

  .chart-container__footer {
    margin-top: 1rem;
    font-size: 1.2rem;
    text-align: center;
  }
}

#detail-chart {
  margin-top: 2rem;
}

@media screen and (max-width: 960px) {
  .chart-title {
    font-size: 1.6rem;
  }

  .chart-container__header-label {
    font-size: 1.6rem !important;
  }
}
.errorText {
  padding: 15rem;
  font-size: 1.6rem;
  text-align: center;
}
</style>
